export default function isAnyAPIFailed(responseData) {
  /** returns true if any API in the list of responses failed
   * Use only if list of APIs are called
   * @param responseData - the responseData returned from useSWR
   */
  return responseData && responseData.some((eachData) => eachData.error)
}
